const ActivityTypeChip = ({ isSelected, children }) => {
  return <div className={`rounded-full pt-1 pb-1 pr-3 pl-3 border-1 border-chLight ${isSelected ? 'bg-secondary' : 'bg-white hover:bg-chLight'}`}>
    <div className='flex items-center'>{children}</div>
  </div>  
}

export default ActivityTypeChip